import React, { useEffect, useState, ChangeEvent } from 'react';
import {
  Alert as AlertMsj,
  Card,
  CardBody,
  Form,
  Button,
  Row,
  Col,
} from 'reactstrap';
import { useUser } from 'context/UserContext';
import { useAlertPlus, useConfirm } from 'hooks';
import { DatePickerChangeEvent } from 'components/DatePicker';
import ConfirmModal from 'components/ConfirmModal';
import AlertModal from 'components/AlertModal';
import { useHistory } from 'react-router-dom';
import { MatriculaRequest } from 'types/Matriculas';
import { getDelegations } from '../../features/delegations/delegationsAPI';
import { Delegations } from 'types/Delegations';
import { getPaises } from '../../features/paises/paisesAPI';
import { Paises } from 'types/Paises';
import { getProvincias } from '../../features/provincias/provinciasAPI';
import { Provincias } from 'types/Provincias';
import { getPartidos } from '../../features/partidos/partidosAPI';
import { Partidos } from 'types/Partidos';
import { getLocalidades } from '../../features/localidades/localidadesAPI';
import { Localidades } from 'types/Localidades';
import { getInstituciones } from '../../features/instituciones/institucionesAPI';
import { Instituciones } from 'types/Instituciones';
import { getTitulos } from '../../features/titulos/titulosAPI';
import { Titulos } from 'types/Titulos';
import { postMatriculaRequest } from '../../features/matriculas/matriculasAPI';
import Stepper from 'components/Stepper';
import StepOne from './Matriculacion/StepOne';
import StepTwo from './Matriculacion/StepTwo';
import StepThree from './Matriculacion/StepThree';
import StepFour from './Matriculacion/StepFour';
import SuccessRequest from './SuccessRequest';
import { getSolicitudMatricula } from '../../features/matriculas/matriculasAPI';

export default function SolicitudMatricula() {
  const { getUser } = useUser();
  const user = getUser();
  if (!user) {
    return null;
  }

  const history = useHistory();
  const [success, setSuccess] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [] = useState<File | null>(null);

  const [formValidation, setFormValidation] = useState<
    Partial<Record<keyof MatriculaRequest, boolean>>
  >({});

  const [disableSend, setDisableSend] = useState(false);

  const [isLoading, setLoading] = useState(true);

  const [showAlert, message, alertCallback, alert] = useAlertPlus('');
  const [confirm, confirmTitle, confirmAction, setConfirm] = useConfirm(false);

  const [delegations, setDelegations] = useState<Delegations[]>([]);

  const [nacimientoPaises, setNacimientoPaises] = useState<Paises[]>([]);
  const [nacimientoProvincias, setNacimientoProvincias] = useState<
    Provincias[]
  >([]);
  const [nacimientoPartidos, setNacimientoPartidos] = useState<Partidos[]>([]);
  const [nacimientoLocalidades, setNacimientoLocalidades] = useState<
    Localidades[]
  >([]);

  const [particularProvincias, setParticularProvincias] = useState<
    Provincias[]
  >([]);
  const [particularPartidos, setParticularPartidos] = useState<Partidos[]>([]);
  const [particularLocalidades, setParticularLocalidades] = useState<
    Localidades[]
  >([]);

  const [legalPartidos, setLegalPartidos] = useState<Partidos[]>([]);
  const [legalLocalidades, setLegalLocalidades] = useState<Localidades[]>([]);

  const [instituciones, setInstituciones] = useState<Instituciones[]>([]);
  const [titulos, setTitulos] = useState<Titulos[]>([]);

  const [data, setData] = useState<Partial<MatriculaRequest>>({
    id: '',
    solicitud_id: '',

    nombre: user.nombre,
    apellido: user.apellido,
    tipo_documento: '',
    nro_documento: user.doc,
    cuit: '',
    sexo: '',
    email: user.email,
    fecha_nac: undefined,
    prefijo_telefono: '',
    telefono: '',
    pais_nac_id: undefined,
    provincia_nac_id: undefined,
    partido_nac_id: undefined,
    localidad_nac_id: undefined,

    delegacion_nro: '',

    particular_calle: '',
    particular_numero: '',
    particular_piso: '',
    particular_dpto: '',
    particular_provincia_id: 0,
    particular_partido_id: 0,
    particular_localidad_id: 0,
    particular_codigo_postal: '',
    particular_prefijo_telefono: '',
    particular_telefono: '',

    legal_calle: '',
    legal_numero: '',
    legal_piso: '',
    legal_dpto: '',
    legal_partido_id: 0,
    legal_localidad_id: 0,
    legal_codigo_postal: '',
    legal_prefijo_telefono: '',
    legal_telefono: '',

    forma_pago: '',
    tipo_tarjeta: '',
    numero_tarjeta_cbu: '',

    titulo_institucion: 0,
    titulo_nombre: 0,
    titulo_fecha: undefined,

    attachs: [],

    motivo_rechazo: '',

    turno_jura_id: 0,
    payment_id: 0,

    state_id: 0,
  });

  useEffect(() => {
    setLoading(true);

    const loadSolicitud = async () => {
      try {
        const response = await getSolicitudMatricula();
        if (response && response.hasOwnProperty('solicitud_id')) {
          await Promise.all([
            loadProvincias('pais_nac_id', response.pais_nac_id ?? 0),
            loadPartidos('provincia_nac_id', response.provincia_nac_id ?? 0),
            loadLocalidades('partido_nac_id', response.partido_nac_id ?? 0),
            loadPartidos('particular_provincia_id', response.particular_provincia_id ?? 0),
            loadLocalidades('particular_partido_id', response.particular_partido_id ?? 0),
            loadLocalidades('legal_partido_id', response.legal_partido_id ?? 0),
          ]);

          loadTitulos();

          setData({
            ...response,
            fecha_nac: response.fecha_nac ? new Date(response.fecha_nac) : undefined,
            titulo_fecha: response.titulo_fecha ? new Date(response.titulo_fecha) : undefined,
          });
        }
      } catch (err) {
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        setDisableSend(true);
        console.error('Home', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {
        setLoading(false);
      }
    };

    const loadData = async () => {
      try {
        let delegationsResponse = await getDelegations();
        if (delegationsResponse) {
          delegationsResponse = delegationsResponse.filter(delegation => delegation.MTR006_ID_DELEGACION !== 0);
          setDelegations(delegationsResponse);
        }

        const paisesResponse = await getPaises();
        if (paisesResponse) {
          setNacimientoPaises(paisesResponse);
        }

        const paisId = 1; // Argentina
        const provinciasResponse = await getProvincias(paisId);
        if (provinciasResponse) {
          setParticularProvincias(provinciasResponse);
        }

        const provinciaId = 1; // Buenos Aires
        const partidosResponse = await getPartidos(provinciaId);
        if (partidosResponse) {
          const partidosFiltrados = partidosResponse.filter(
            partido => ![2698, 2833].includes(partido.MTR038_ID_PARTIDO), // Filtramos para excluir CABA y "No Informado"
          );
          setLegalPartidos(partidosFiltrados);
        }

        const institucionesResponse = await getInstituciones();
        if (institucionesResponse) {
          setInstituciones(institucionesResponse);
        }
      } catch (err) {
        setDisableSend(true);
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('Matriculation', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {
        loadSolicitud();
      }
    };

    loadData();
  }, []);

  let fileFields = [
    'foto_carnet',
    'titulo_adjunto',
    'fotocopia_dni_frente',
    'fotocopia_dni_dorso',
    'antecedentes_penales',
  ];

  useEffect(() => {
    if (data.pais_nac_id == 1) {
      fileFields = fileFields.filter(type => type != 'certificado_extranjero');
    } else {
      fileFields.push('certificado_extranjero');
    }
  }, [data.pais_nac_id]);

  const loadTitulos = async () => {
    try {
      setLoading(true);

      if (!data.titulo_institucion) {
        return;
      }

      const titulosResponse = await getTitulos(data.titulo_institucion);
      setTitulos(titulosResponse);
    } catch (err) {
      setDisableSend(true);
      alert(
        'Se produjo un error al intentar recuperar los títulos. ' +
          'Por favor, intente nuevamente más tarde.',
      );
      console.error('Matriculation', 'Error al cargar los títulos');
      console.info(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTitulos();
  }, [data.titulo_institucion]);

  const nextStep = () => setCurrentStep(prev => Math.min(prev + 1, 4));
  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(prev => Math.max(prev - 1, 1));
    } else {
      history.push('/inicio');
    }
  };

  const hasAttachment = (type: string) => {
    return data.attachs?.some(a => a.attachment_type.startsWith(type));
  };

  const handleFormValidation = () => {
    let newFormValidation = {};

    let toValidate = [
      ...Array.from(document.getElementsByClassName('form-control')),
    ] as HTMLInputElement[];
    toValidate = toValidate.filter(e => !e.disabled && e.required);

    let missing = false;
    // Validar campos required
    toValidate.forEach(field => {
      if (field.required && !field.disabled && !field.value?.trim()) {
        if (!fileFields.includes(field.name)) {
          field.classList.add('is-invalid');
          missing = true;
        } else {
          if (!hasAttachment(field.name)) {
            field.classList.add('is-invalid');
            missing = true;
          }
        }
      } else if (field.inputMode === 'numeric') {
        if (!/^\d+$/.test(field.value)) {
          newFormValidation = {
            ...newFormValidation,
            [field.name]: false,
          };
        }
      } else {
        field.classList.remove('is-invalid');
      }
    });

    if (missing) {
      setFormValidation(newFormValidation);
      alert(
        'Todos los campos marcados con * son obligatorios. ' +
          'Por favor complete los faltantes antes de enviar la solicitud.',
      );
      return false;
    }

    if (data.pais_nac_id == 1 && !data.localidad_nac_id) {
      alert('Debe seleccionar la localidad de nacimiento.');
      return false;
    }

    return true;
  };

  // Confirmación de envío de Solicitud
  const handleSendForm = () => {
    if (!handleFormValidation()) {
      return;
    }

    setConfirm(
      true,
      '¿Estás seguro que deseas enviar esta solicitud de matriculación?',
      'send',
    );
  };

  // Gestor de respuestas de confirmaciones
  const handleConfirmation = (action: string) => {
    if (action === 'send') {
      handleSend();
    }

    setConfirm(false);
  };

  // Envío de solicitudes
  const handleSend = () => {
    setFormValidation({});

    setLoading(true);

    // Preparamos los archivos
    const files: Record<string, File> = {};
    const inputs = Array.from(document.querySelectorAll('input[type="file"]'));
    for (const inputElement of inputs) {
      const input = inputElement as HTMLInputElement;
      if (input.hasAttribute('required') && input.value === '') {
        alert(
          'Faltan subir archivos requeridos para poder enviar la solicitud.',
        );
        setLoading(false);
        return;
      }

      if (input.files) {
        for (let i = 0; i < input.files.length; i++) {
          files[`${input.name}_${i}`] = input.files[i];
        }
      }
    }

    postMatriculaRequest(data, files)
      .then(res => {
        if (!res || res.status !== 'ok') {
          // Error interno
          console.error('Matriculation', 'Error al enviar la solicitud');
          console.info(res);
          alert(
            res.message ??
            'Ha ocurrido un error al enviar la solicitud. Por favor intente nuevamente.',
          );
          setSuccess(false);
          return;
        }

        setData({
          ...data,
          motivo_rechazo: '',
        });
        setSuccess(true);
      })
      .catch(err => {
        console.error(
          'Matriculation',
          'Error inesperado al intentar enviar la solicitud',
        );
        console.info(err);
        alert(
          err.message ??
          'Ha ocurrido un error al enviar la solicitud. Por favor intente nuevamente.',
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loadProvincias = async (name: string, value: number) => {
    if (value == 1) {
      const provinciasResponse = await getProvincias(value);
      if (provinciasResponse) {
        switch (name) {
          case 'pais_nac_id':
            setNacimientoProvincias(provinciasResponse);
            break;
        }
      }
    }
  };

  const loadPartidos = async (name: string, value: number) => {
    const partidosResponse = await getPartidos(value);
    if (partidosResponse) {
      switch (name) {
        case 'provincia_nac_id':
          setNacimientoPartidos(partidosResponse);
          break;
        case 'particular_provincia_id':
          setParticularPartidos(partidosResponse);
          break;
      }
    }
  };

  const loadLocalidades = async (name: string, value: number) => {
    setDisableSend(true);
    try {
      const localidadesResponse = await getLocalidades(value);
      if (localidadesResponse) {
        switch (name) {
          case 'partido_nac_id':
            setNacimientoLocalidades(localidadesResponse);
            break;
          case 'particular_partido_id':
            setParticularLocalidades(localidadesResponse);
            break;
          case 'legal_partido_id':
            const localidadesFiltrados = localidadesResponse.filter(
              localidad => ![1083].includes(localidad.MTR008_ID_LOCALIDAD), // Filtramos para excluir "No Informada"
            );
            setLegalLocalidades(localidadesFiltrados);
            break;
        }
        setDisableSend(false);
      } else {
        alert('Error al cargar las localidades. Por favor intente seleccionar el partido nuevamente.');
      }
    } catch (err) {
      alert('Error al cargar las localidades. Por favor intente seleccionar el partido nuevamente.');
    }
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement> | DatePickerChangeEvent) => {
    const { target } = event;

    const name = target.name;

    let value: string | number | Date | null;
    value = target.value;
    if (
      typeof value === 'string' &&
      ['dni', 'telefono', 'legal_telefono', 'legal_celular'].includes(
        name,
      )
    ) {
      value = !!parseInt(value) ? parseInt(value) : '';
    }

    let lugarNac = {};
    // Si se elije el país Argentina
    if (['pais_nac_id'].includes(name)) {
      if (value == 1) {
        loadProvincias(name, value as number);
      } else {
        lugarNac = {
          provincia_nac_id: null,
          partido_nac_id: null,
          localidad_nac_id: null,
        };
      }
    }

    if (['provincia_nac_id', 'particular_provincia_id'].includes(name)) {
      loadPartidos(name, value as number);
    }

    if (['partido_nac_id', 'particular_partido_id', 'legal_partido_id'].includes(name)) {
      loadLocalidades(name, value as number);
    }

    // Guardamos el nuevo valor
    setData({
      ...data,
      ...lugarNac,
      [name]: value,
    });
  };


  const validateStep = (requiredFields: string[], isForm = true): boolean => {
    let missing = false;
    // Inicializamos un objeto para la validación
    let newFormValidation = {};

    if (isForm) {
      let toValidate = [
        ...Array.from(document.getElementsByClassName('form-control')),
      ] as HTMLInputElement[];

      toValidate = toValidate.filter(e => !e.disabled && e.required && requiredFields.includes(e.name));

      // Validar campos required
      toValidate.forEach(field => {
        if (field.required && !field.disabled && !field.value?.trim()) {
          if (!fileFields.includes(field.name)) {
            field.classList.add('is-invalid');
            missing = true;
          } else {
            if (!hasAttachment(field.name)) {
              field.classList.add('is-invalid');
              missing = true;
            }
          }
        } else if (field.inputMode === 'numeric') {
          if (!/^\d+$/.test(field.value)) {
            newFormValidation = {
              ...newFormValidation,
              [field.name]: false,
            };
          }
        } else {
          field.classList.remove('is-invalid');
        }
      });
    } else {
      requiredFields.map(field => {
        missing = missing || !data.hasOwnProperty(field) || !(data as any)[field];
      });
    }

    if (missing) {
      setFormValidation(newFormValidation);
      alert(
        'Todos los campos marcados con * son obligatorios. ' +
          'Por favor complete los faltantes antes de continuar.',
      );
      return false;
    }

    return true;
  };

  return (
    <div className="content">
      <Col sm={4}>
        <Button
          className="btn-round"
          color="primary"
          onClick={prevStep}
        >
          Volver
        </Button>
      </Col>
      {data.state_id === 3 && data.motivo_rechazo
        ?
          <AlertMsj color="danger">
            <Row className="mb-2">
              <Col sm={12}>
                <span className='group-name observations'>
                  <strong>Motivo Rechazo</strong>
                  <p className="mt-2">
                    { data.motivo_rechazo }
                  </p>
                </span>
              </Col>
            </Row>
          </AlertMsj>
        : null
      }
      <Row>
        <Col sm={12}>
          <Card>
            <Stepper
              currentStep={success ? 5 : currentStep}
              steps={[
                'Datos Personales',
                'Dirección Particular',
                'Pago',
                'Adjuntos',
              ]}
              title="Solicitud de Matriculación"
            />
            {success ? (
              <SuccessRequest />
            ) : (
              <CardBody style={{ paddingTop: 0 }}>
                <Form>
                  {currentStep === 1 && (
                    <StepOne
                      data={data}
                      formValidation={formValidation}
                      handleInputChange={handleInputChange}
                      isLoading={isLoading}
                      nacimientoPaises={nacimientoPaises}
                      nacimientoProvincias={nacimientoProvincias}
                      nacimientoPartidos={nacimientoPartidos}
                      nacimientoLocalidades={nacimientoLocalidades}
                      delegations={delegations}
                      onNext={nextStep}
                      validateStep={validateStep}
                      disableSend={disableSend}
                    />
                  )}
                  {currentStep === 2 && (
                    <StepTwo
                      data={data}
                      formValidation={formValidation}
                      handleInputChange={handleInputChange}
                      isLoading={isLoading}
                      particularProvincias={particularProvincias}
                      particularPartidos={particularPartidos}
                      particularLocalidades={particularLocalidades}
                      legalPartidos={legalPartidos}
                      legalLocalidades={legalLocalidades}
                      onNext={nextStep}
                      onBack={prevStep}
                      validateStep={validateStep}
                      disableSend={disableSend}
                    />
                  )}
                  { currentStep === 3 && (
                    <StepThree
                      data={data}
                      formValidation={formValidation}
                      handleInputChange={handleInputChange}
                      isLoading={isLoading}
                      onNext={nextStep}
                      onBack={prevStep}
                      validateStep={validateStep}
                      disableSend={disableSend}
                    />
                  )}
                  {currentStep === 4 && (
                    <StepFour
                      data={data}
                      formValidation={formValidation}
                      handleInputChange={handleInputChange}
                      isLoading={isLoading}
                      instituciones={instituciones}
                      titulos={titulos}
                      onBack={prevStep}
                      disableSend={disableSend}
                      validateStep={validateStep}
                      handleSendForm={handleSendForm}
                    />
                  )}
                </Form>
                <AlertModal
                  isOpen={showAlert}
                  message={message}
                  onClose={alertCallback}
                />
                <ConfirmModal
                  isOpen={confirm}
                  title={confirmTitle}
                  action={confirmAction}
                  onClose={() => setConfirm(false)}
                  onConfirm={handleConfirmation}
                />
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
}
